module.exports = __webpack_public_path__ + "c6b9d9e1ff3d61320dcf39abcd06798b.jpg";